<template>
  <div class="flex h-screen flex-col">
    <ViewHeader
      :name="headerName"
      :back-route="backRoute"
      :title-key="titleKey">
      <ApplicationDetailCustomHeader />
      <template #tabs>
        <div class="" style="padding-left: var(--home-padding)">
          <ApplicationDetailsTabs />
        </div>
      </template>
    </ViewHeader>

    <main class="flex-1">
      <RouterView v-slot="{ Component, route: routeSlot }">
        <component :is="Component" :key="routeSlot.fullPath" />
      </RouterView>
    </main>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import ApplicationDetailsTabs from '@/components/ApplicationDetailsTabs.vue'

  const route = useRoute()
  const headerName = computed(function () {
    return typeof route.name === 'string' ? route.name : undefined
  })

  const backRoute = computed(function () {
    const meta = route.meta as Record<string, unknown> | undefined
    const val = meta && (meta as Record<string, unknown>).backRoute
    return typeof val === 'string' ? val : undefined
  })

  const titleKey = computed(function () {
    const meta = route.meta as Record<string, unknown> | undefined
    const val = meta && (meta as Record<string, unknown>).titleKey
    return typeof val === 'string' ? val : undefined
  })
</script>

<style lang="css" scoped>
  .hinge-right-enter-active,
  .hinge-right-leave-active,
  .hinge-left-enter-active,
  .hinge-left-leave-active {
    transition:
      opacity 140ms cubic-bezier(0.2, 0.7, 0.2, 1),
      transform 150ms cubic-bezier(0.2, 0.7, 0.2, 1);
    will-change: opacity, transform;
    transform-style: preserve-3d;
  }

  /* von links reinkippen (rotateY + translateX) */
  .hinge-right-enter-from {
    opacity: 0;
    transform: translateX(8px) rotateY(-6deg);
  }

  .hinge-right-leave-to {
    opacity: 0;
    transform: translateX(-8px) rotateY(6deg);
  }

  /* von rechts reinkippen */
  .hinge-left-enter-from {
    opacity: 0;
    transform: translateX(-8px) rotateY(6deg);
  }

  .hinge-left-leave-to {
    opacity: 0;
    transform: translateX(8px) rotateY(-6deg);
  }

  /* reduced motion */
  @media (prefers-reduced-motion: reduce) {
    .hinge-right-enter-active,
    .hinge-right-leave-active,
    .hinge-left-enter-active,
    .hinge-left-leave-active {
      transition: none;
    }
  }
</style>
